import { Box, Grid, Typography } from "@mui/material";
import React from "react";

type IProps = {
	fields: {
		label: string;
		value: string | React.ReactNode;
	}[];
};

const DetailsDataShowByGrid = ({ fields }: IProps) => {
	return (
		<Box sx={{ width: "100%" }}>
			<Grid container spacing={{ xs: 1, sm: 1.5, md: 1.75 }}>
				{fields?.map((field, index) => (
					<Grid item xs={12} sm={6} md={4} key={index}>
						<Box
							sx={{
								display: "flex",
								alignItems: "baseline",
								minHeight: "24px",
							}}
						>
							<Typography
								component="span"
								sx={{
									width: { xs: "125px", sm: "135px", md: "140px" },
									flexShrink: 0,
									fontWeight: 600,
									color: "#475569",
									fontSize: "0.8125rem",
									lineHeight: 1.35,
								}}
							>
								{field.label}
							</Typography>
							<Typography
								component="span"
								sx={{
									width: "12px",
									flexShrink: 0,
									fontWeight: 700,
									color: "#94A3B8",
									textAlign: "center",
									mr: 1,
									fontSize: "0.8125rem",
								}}
							>
								:
							</Typography>
							<Box
								component="span"
								sx={{
									flex: 1,
									fontSize: "0.825rem",
									fontWeight: 500,
									color: "#0F172A",
									wordBreak: "break-word",
									lineHeight: 1.35,
								}}
							>
								{field.value || "N/A"}
							</Box>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default DetailsDataShowByGrid;
